import React from "react";
import Input, { InputProps } from "antd/es/input";
import Form, { FormItemProps } from "antd/es/form";

interface InputFieldProps {
  validationMessage?: string;
}

const InputField: React.FC<InputProps & FormItemProps & InputFieldProps> = ({
  name,
  label,
  placeholder,
  preserve,
  required,
  type = "text",
  validationMessage = "Заповніть це поле",
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      preserve={preserve}
      rules={[{ required, message: validationMessage }]}
    >
      {type === "textarea" ? (
        <Input.TextArea placeholder={placeholder} autoSize={{ minRows: 2 }} />
      ) : (
        <Input type={type} placeholder={placeholder} />
      )}
    </Form.Item>
  );
};

export default InputField;
